// The words the state surfaces show. An instance with no filters names only search.

export const ERROR_COPY = {
  title: 'Could not load this table',
  description: 'The data could not be loaded. Try again.',
  action: 'Retry',
}

export const zeroResultsCopy = hasFilters =>
  hasFilters
    ? {
        title: 'No results match your search or filters',
        action: 'Clear search and filters',
      }
    : {
        title: 'No results match your search',
        action: 'Clear search',
      }
